/// <summary>
/// AB下发的数据对象
/// </summary>
/// <author>xiexingwu</author>
import {JObject} from "@/Fwk/Kit/JObject";

export class ABEntity {
    public code = "";
    public message = "";
    public timestamp: number = 0;
    public etag = "";
    public fromEtag = "0";
    public data = "";
    public match_ab_experiment = 0;
    public hadAbExperiment = false;

    public ab_id = "";
    public ab_name = "";
    public ab_group_id = "";

    public ab_group_name = "";

    // 解析后参数
    public orthogonalMapStr = "";
    public abExperimentData: JObject[] | null = null;
    public variables = "";
    private variablesMap = new Map<string, string>();

    public country = "";

    getDataString(key: string): string {
        return this.variablesMap.has(key) ? this.variablesMap.get(key) ?? "" : "";
    }

    //只存运营配置，本地手动存的其他数据没做实时更新
    putDataString(key: string, value: string) {
        this.variablesMap.set(key, value);
    }
}
